"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupLink = exports.EmailSentText = exports.CloseIcon = exports.SubmitButton = exports.InputContainer = exports.ButtonContainer = exports.ErrorText = exports.ErrorContainer = exports.ButtonText = exports.SignupText = exports.NoAccountContainer = exports.IconContainer = exports.Title = exports.MainContainer = exports.LoginContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Typography_1 = __importDefault(require("../../UI/Typography"));
const Button_1 = __importDefault(require("../../Button"));
const svg_components_1 = require("../../../assets/svg-components");
exports.LoginContainer = (0, styled_components_1.default)(styled_bootstrap_grid_1.Container) `
  margin-top: ${props => props.theme.spacing.xl2}px;
  background-color: ${props => props.theme.palette.BW_100};
  position: relative;
  max-width: ${props => props.theme.constants.loginModalWidth.lg}px;
  height: max-content;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: 0;
    height: 100vh;
  }
`;
exports.MainContainer = styled_components_1.default.form `
  padding: ${props => props.theme.spacing.l2}px ${props => props.theme.spacing.m6}px
    ${props => props.theme.spacing.m6}px ${props => props.theme.spacing.m6}px;
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  margin-bottom: ${props => props.theme.spacing.m3}px;
`;
exports.IconContainer = styled_components_1.default.button `
  border: none;
  background: none;
  display: flex;
  justify-content: flex-end;
  padding: ${props => props.theme.spacing.s4}px 0;
  width: 100%;

  > svg {
    > path {
      fill: ${props => props.theme.palette.BLUE_GRAY_40};
    }
  }
`;
exports.NoAccountContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
exports.SignupText = (0, styled_components_1.default)(Typography_1.default) `
  ${props => props.addMargin && `margin-right: ${props.theme.spacing.s2}px;`}
`;
exports.ButtonText = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.HALDEX_BLUE};
`;
exports.ErrorContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${props => props.theme.palette.RED_40};
  background-color: ${props => props.theme.palette.RED_10};
  padding: ${props => props.theme.spacing.s4}px;
  border-radius: ${props => props.theme.attributes.borderRadius.xs}px;
  margin-bottom: ${props => props.theme.spacing.m3}px;
`;
exports.ErrorText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s2}px;
  color: ${props => props.theme.palette.RED_100};
`;
exports.ButtonContainer = styled_components_1.default.div `
  width: 100%;
  margin: ${props => props.theme.spacing.m3}px 0;
`;
exports.InputContainer = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.m3}px;
`;
exports.SubmitButton = (0, styled_components_1.default)(Button_1.default) `
  width: 100%;
`;
exports.CloseIcon = (0, styled_components_1.default)(svg_components_1.BurgerClosedIcon) `
  cursor: pointer;
`;
exports.EmailSentText = (0, styled_components_1.default)(Typography_1.default) ``;
exports.SignupLink = styled_components_1.default.a `
  font-size: ${props => props.theme.typography.size.defaultSize}px;
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  color: ${props => props.theme.palette.BLUE_100};
  text-decoration: none;
`;
exports.default = {
    LoginContainer: exports.LoginContainer,
    MainContainer: exports.MainContainer,
    IconContainer: exports.IconContainer,
    NoAccountContainer: exports.NoAccountContainer,
    SignupText: exports.SignupText,
    ButtonText: exports.ButtonText,
    ErrorContainer: exports.ErrorContainer,
    ErrorText: exports.ErrorText,
    ButtonContainer: exports.ButtonContainer,
    InputContainer: exports.InputContainer,
    SubmitButton: exports.SubmitButton,
    CloseIcon: exports.CloseIcon,
    EmailSentText: exports.EmailSentText,
    SignupLink: exports.SignupLink,
    Title: exports.Title
};
